import React from "react";
import Context from "../../../Context";
import Blocker from "../../Misc/Blocker";
import CrumbsProvider from "../../Misc/CrumbsProvider";
import Scrollpane from "../../Misc/Scrollpane";
import visualState from "../../../visualState";
import JournalTree from "./JournalTree";
import JournalList from "./JournalList";
import SVGFolder1 from "../../Misc/SvgIcons/SVGFolder1";
import JournalItem from "./JournalItem";
import { Link } from "react-router-dom";
export default class Journal extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);

    this.vState = new visualState("JournalSection");

    this.state = {
      pending: false,
      tree: {},
      customListKey: "",
      structureVisible: this.vState.read("structureVisible", true),
    };
  }

  componentDidMount() {
    this.load();
    this.renderButtons();
  }

  componentDidUpdate() {
    this.renderButtons();
  }

  load = async () => {
    this.setState({ pending: true });

    let tree = await this.context.api.qoo(
      `/journal/tree/list`,
      { search: [] },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({ pending: false, tree });
  };

  toggleVisibleStructure = () => {
    this.setState((state) => {
      this.vState.save({ structureVisible: !state.structureVisible });
      return { structureVisible: !state.structureVisible };
    });
  };

  renderButtons = () => {
    this.context.actionsSet(
      <>
        <button
          title="Журнал на всю ширину"
          onClick={this.toggleVisibleStructure}
          className={`btn btn-icon ${
            !this.state.structureVisible
              ? "bg-light-primary bg-hover-light"
              : "bg-light bg-hover-light-primary"
          }    mr-2`}
        >
          <i className="fa fa-arrows-h"></i>
        </button>
      </>
    );
  };

  render() {
    const { nodeId, itemId, mode, itemMode, recentItemId } = this.props;
    const { tree, pending, structureVisible } = this.state;

    return (
      <>
        <CrumbsProvider title="Журналы" link="/journal/" />
        <Blocker spinnerFixed hAuto on={this.state.pending}>
          <div className="row h-100">
            {structureVisible && (
              <>
                <div className="col-lg-3 border-right no-print">
                  <Scrollpane>
                    <div
                      className={`p-1 bg-hover-light ${
                        nodeId === "any" && "bg-light"
                      }`}
                    >
                      <Link
                        className={` d-block text-dark   ${
                          nodeId === "any" && "bg-light "
                        }`}
                        to={`/journal/any/`}
                      >
                        <i className="fa fa-list mr-3"></i> Все
                      </Link>
                    </div>
                    <JournalTree
                      items={tree}
                      nodeId={pending ? null : nodeId}
                      itemId={itemId}
                    />
                  </Scrollpane>
                </div>
                <div className="col-lg-3 border-right no-print">
                  <Scrollpane>
                    <JournalList
                      customListKey={this.state.customListKey}
                      {...this.props}
                    />
                  </Scrollpane>
                </div>
              </>
            )}

            <div className="col h-100">
              <Scrollpane>
                <JournalItem nodeId={nodeId} itemId={itemId} />
              </Scrollpane>
            </div>
          </div>
        </Blocker>
      </>
    );
  }
}
